import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SystemOptions } from '../constants/options-system';

export const desktopOnlyGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const minWidth = SystemOptions.MinWidth;

  // if (typeof window !== 'undefined' && window.innerWidth < minWidth) {
  //   router.navigate(['/desktop-only']);
  //   return false;
  // }
  
  return true;
};
